
import { useEffect, useRef } from "react";
import { MessageCircle, Heart } from "lucide-react";

const CLIENT_ID = "ca-pub-4043314376774351";
const SLOT_ID = "1273102451";

export default function AdSenseBanner() {
  const adRef = useRef(null);

  useEffect(() => {
    const ad = adRef.current;
    if (!ad || ad.dataset.adInitialized) return;

    // Prevent duplicate initialization of this element.
    if (ad.getAttribute("data-adsbygoogle-status")) return;

    ad.dataset.adInitialized = "true";

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      delete ad.dataset.adInitialized;
      console.error("AdSense initialization failed:", error);
    }
  }, []);

  return (
    <section className="w-full px-3 py-10 sm:px-6 sm:py-14">
      <div className="mx-auto max-w-7xl">
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-3 sm:p-6">
          <div className="flex w-full justify-center">
            <div className="w-full max-w-[970px] min-w-0">
              <ins
                ref={adRef}
                className="adsbygoogle"
                style={{ display: "block", width: "100%", minHeight: "100px" }}
                data-ad-client={CLIENT_ID}
                data-ad-slot={SLOT_ID}
                data-ad-format="auto"
                data-full-width-responsive="true"
              />
            </div>
          </div>

          <div className="mt-5 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-4 text-center sm:flex-row sm:text-left">
            <p className="flex items-start gap-2 text-xs leading-relaxed text-white/60">
              <Heart size={14} className="mt-0.5 shrink-0 text-[#FFBF00]" />
              <span>
                Ads help keep <strong className="text-white">LostDC Network</strong>
                {" "}free and support new features. Thank you!
              </span>
            </p>

            <a
              href="https://lostdrkc.in/discord"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-white/45 hover:text-[#7289DA]"
            >
              <MessageCircle size={13} />
              Contact support via Discord
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
